import React from "react";
import Layout from "./Layout";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty } from "lodash";

const ReferWeb = () => {
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  return (
    <Layout>
      <div className="margin-desktop my-5">
        <div className="desktop_referral_card hidden-sm-and-down bfrLoginContainer v-card v-sheet theme--light">
          <div className="v-card__title" />
          <div className="bfrLogin">
            <div>
              <div
                className="row px-4 no-gutters"
                style={{ position: "relative" }}
              >
                <img
                  loading="lazy"
                  src="/assets/icon/topLeft-coin.png"
                  className="topLeft-coin"
                />
                <img
                  loading="lazy"
                  src="/assets/icon/bottomLeft-coin.png"
                  className="bottomLeft-coin"
                />
                <img
                  loading="lazy"
                  src="/assets/icon/topRight-coin.png"
                  className="topRight-coin"
                />
                <img
                  loading="lazy"
                  src="/assets/icon/bottomRight-coin.png"
                  className="bottomRight-coin"
                />
                <div className="v-image v-responsive newReferralBanner-desktop theme--light">
                  <div
                    className="v-responsive__sizer"
                    style={{ "padding-bottom": "18.3908%" }}
                  />
                  <div
                    className="v-image__image v-image__image--cover"
                    style={{
                      "background-image":
                        'url("/assets/new/referralinnerbanner-desktop.jpg")',
                      "background-position": "center center",
                    }}
                  />
                  <div className="v-responsive__content">
                    <div className="banner-desc">
                      <div className="pb-4">
                        <span>Every friend you refer, you will get free</span>
                        <h1 className="prizeText">৳500 </h1>
                        <span>Your friends will receive a free ৳500 too! </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isEmpty(user) && (
              <div className="v-card__subtitle">
                <div>
                  <div className="row pt-2 no-gutters">
                    <div className="col col-12">
                      <span
                        style={{ "font-weight": "bold", "font-size": "18px" }}
                      >
                        Login or register as a member to get your referral code
                      </span>
                    </div>
                  </div>
                  <div className="row pt-2 no-gutters">
                    <div className="col col-12">
                      <button
                        onClick={() => navigate("/register")}
                        type="button"
                        className="v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary-button mr-6 subtitle-1 full-width white--text pa-2 theme-button embedded-button "
                        style={{
                          width: "150px !important",
                          "background-color": "rgb(255, 0, 198)",
                        }}
                      >
                        <span className="v-btn__content">Sign Up</span>
                      </button>
                      <button
                        onClick={() => navigate("/login")}
                        type="button"
                        className="embedded-button primary-button embedded-login-button pa-2 black--text subtitle-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                        style={{
                          height: "auto",
                          width: "150px !important",
                          "background-color": "rgb(198, 255, 0)",
                        }}
                      >
                        <span className="v-btn__content">Login</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="bfrLogin mt-3">
            <div className="v-card__text">
              <div className="row">
                <div className="col col-12">
                  <div className="ml-4 pt-2">
                    <div className="hidden-sm-and-down">
                      <div className="row refer-timeline">
                        <div className="pb-0 col col-12">
                          <span className="referral-title">
                            LifeTime Referral Commission
                          </span>
                        </div>
                        <div className="pt-0 col col-12">
                          <span className="referral-description font-weight-bold">
                            You also get to earn an additional lifetime deposit
                            commission of up to 5% from your friends every time
                            they make a deposit.
                          </span>
                        </div>
                        <div className="timeline-container col col-9">
                          <div className="v-timeline pt-0 v-timeline--dense theme--light">
                            <div className="v-timeline-item active-tier v-timeline-item--fill-dot theme--light">
                              <div className="v-timeline-item__body">
                                <div
                                  className="row"
                                  style={{
                                    "-webkit-align-items": "center",
                                    "-webkit-box-align": "center",
                                    "-ms-flex-align": "center",
                                    "align-items": "center",
                                  }}
                                >
                                  <div className="col col-5">
                                    <div className="tier-card text-center active-tier v-card v-sheet theme--light">
                                      <div className="v-card__text font-weight-bold">
                                        You
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col col-2"
                                    style={{ padding: "unset" }}
                                  >
                                    <div className="tier-card text-center active-tier v-card v-sheet theme--light">
                                      <div className="v-card__text font-weight-bold">
                                        Total
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="v-timeline-item__divider">
                                <div className="v-timeline-item__dot">
                                  <div
                                    className="v-timeline-item__inner-dot"
                                    style={{
                                      "background-color": "rgb(51, 51, 51)",
                                      "border-color": "rgb(51, 51, 51)",
                                    }}
                                  >
                                    <img
                                      src="/assets/icon/tier-icon.svg"
                                      style={{ width: "15px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                              <div className="v-timeline-item__body">
                                <div
                                  className="row"
                                  style={{
                                    "-webkit-align-items": "center",
                                    "-webkit-box-align": "center",
                                    "-ms-flex-align": "center",
                                    "align-items": "center",
                                  }}
                                >
                                  <div className="col col-5">
                                    <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                      <div className="v-card__text font-weight-bold black--text">
                                        Tier 1 (2.5%)
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col col-2"
                                    style={{ padding: "unset" }}
                                  >
                                    <div className="v-card v-sheet theme--light">
                                      <div className="v-card__text tier-card text-center black--text font-weight-bold">
                                        0
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="v-timeline-item__divider">
                                <div className="v-timeline-item__dot">
                                  <div
                                    className="v-timeline-item__inner-dot"
                                    style={{
                                      "background-color": "rgb(217, 217, 217)",
                                      "border-color": "rgb(217, 217, 217)",
                                    }}
                                  >
                                    <img
                                      src="/assets/icon/tier-icon-black.svg"
                                      style={{ width: "15px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                              <div className="v-timeline-item__body">
                                <div
                                  className="row"
                                  style={{
                                    "-webkit-align-items": "center",
                                    "-webkit-box-align": "center",
                                    "-ms-flex-align": "center",
                                    "align-items": "center",
                                  }}
                                >
                                  <div className="col col-5">
                                    <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                      <div className="v-card__text font-weight-bold black--text">
                                        Tier 2 (1.5%)
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col col-2"
                                    style={{ padding: "unset" }}
                                  >
                                    <div className="v-card v-sheet theme--light">
                                      <div className="v-card__text tier-card text-center black--text font-weight-bold">
                                        0
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="v-timeline-item__divider">
                                <div className="v-timeline-item__dot">
                                  <div
                                    className="v-timeline-item__inner-dot"
                                    style={{
                                      "background-color": "rgb(217, 217, 217)",
                                      "border-color": "rgb(217, 217, 217)",
                                    }}
                                  >
                                    <img
                                      src="/assets/icon/tier-icon-black.svg"
                                      style={{ width: "15px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                              <div className="v-timeline-item__body">
                                <div
                                  className="row"
                                  style={{
                                    "-webkit-align-items": "center",
                                    "-webkit-box-align": "center",
                                    "-ms-flex-align": "center",
                                    "align-items": "center",
                                  }}
                                >
                                  <div className="col col-5">
                                    <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                      <div className="v-card__text font-weight-bold black--text">
                                        Tier 3 (1.0%)
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="col col-2"
                                    style={{ padding: "unset" }}
                                  >
                                    <div className="v-card v-sheet theme--light">
                                      <div className="v-card__text tier-card text-center black--text font-weight-bold">
                                        0
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="v-timeline-item__divider">
                                <div className="v-timeline-item__dot">
                                  <div
                                    className="v-timeline-item__inner-dot"
                                    style={{
                                      "background-color": "rgb(217, 217, 217)",
                                      "border-color": "rgb(217, 217, 217)",
                                    }}
                                  >
                                    <img
                                      src="/assets/icon/tier-icon-black.svg"
                                      style={{ width: "15px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row hidden-md-and-up">
                      <div className="col col-12">
                        <p>
                          Share your referral code with your friend now and
                          start earning extra cash for every friend you invite.
                        </p>
                        <div className="row">
                          <div className="col col-12">
                            <span>
                              Login / Register to get your referral code:
                            </span>
                          </div>
                          <div className="inpage-before-login-first text-center beforeLoginBtn col">
                            <b>Sign Up</b>
                          </div>
                          <div className="inpage-navigator-before-login-second text-center beforeLoginBtn col">
                            <b>Login</b>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row hidden-md-and-up">
                      <div className="timeline-container col col">
                        <div className="v-timeline v-timeline--dense theme--light">
                          <div className="v-timeline-item active-tier v-timeline-item--fill-dot theme--light">
                            <div className="v-timeline-item__body">
                              <div
                                className="row"
                                style={{
                                  "-webkit-align-items": "center",
                                  "-webkit-box-align": "center",
                                  "-ms-flex-align": "center",
                                  "align-items": "center",
                                }}
                              >
                                <div className="col col-12">
                                  <div className="tier-card text-center active-tier v-card v-sheet theme--light">
                                    <div className="v-card__text">You</div>
                                  </div>
                                </div>
                                {/**/}
                              </div>
                            </div>
                            <div className="v-timeline-item__divider">
                              <div className="v-timeline-item__dot">
                                <div className="v-timeline-item__inner-dot grey lighten-2">
                                  <img
                                    src="/assets/icon/tier-icon.svg"
                                    style={{ width: "22px" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                            <div className="v-timeline-item__body">
                              <div
                                className="row"
                                style={{
                                  "-webkit-align-items": "center",
                                  "-webkit-box-align": "center",
                                  "-ms-flex-align": "center",
                                  "align-items": "center",
                                }}
                              >
                                <div className="col col-12">
                                  <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                    <div className="v-card__text">
                                      Tier 1 (2.5%)
                                    </div>
                                  </div>
                                </div>
                                {/**/}
                              </div>
                            </div>
                            <div className="v-timeline-item__divider">
                              <div className="v-timeline-item__dot">
                                <div className="v-timeline-item__inner-dot grey lighten-2">
                                  <img
                                    src="/assets/icon/tier-icon.svg"
                                    style={{ width: "22px" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                            <div className="v-timeline-item__body">
                              <div
                                className="row"
                                style={{
                                  "-webkit-align-items": "center",
                                  "-webkit-box-align": "center",
                                  "-ms-flex-align": "center",
                                  "align-items": "center",
                                }}
                              >
                                <div className="col col-12">
                                  <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                    <div className="v-card__text">
                                      Tier 2 (1.5%)
                                    </div>
                                  </div>
                                </div>
                                {/**/}
                              </div>
                            </div>
                            <div className="v-timeline-item__divider">
                              <div className="v-timeline-item__dot">
                                <div className="v-timeline-item__inner-dot grey lighten-2">
                                  <img
                                    src="/assets/icon/tier-icon.svg"
                                    style={{ width: "22px" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="v-timeline-item v-timeline-item--fill-dot theme--light">
                            <div className="v-timeline-item__body">
                              <div
                                className="row"
                                style={{
                                  "-webkit-align-items": "center",
                                  "-webkit-box-align": "center",
                                  "-ms-flex-align": "center",
                                  "align-items": "center",
                                }}
                              >
                                <div className="col col-12">
                                  <div className="tier-card text-center v-card v-sheet theme--light grey lighten-2">
                                    <div className="v-card__text">
                                      Tier 3 (1.0%)
                                    </div>
                                  </div>
                                </div>
                                {/**/}
                              </div>
                            </div>
                            <div className="v-timeline-item__divider">
                              <div className="v-timeline-item__dot">
                                <div className="v-timeline-item__inner-dot grey lighten-2">
                                  <img
                                    src="/assets/icon/tier-icon.svg"
                                    style={{ width: "22px" }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="justify-space-around referralLayout hidden-md-and-up v-card v-sheet theme--light elevation-0">
          <div className="v-image v-responsive theme--light">
            <div
              className="v-responsive__sizer"
              style={{ "padding-bottom": "23.0769%" }}
            />
            <div
              className="v-image__image v-image__image--preload v-image__image--cover"
              style={{ "background-position": "center center" }}
            />
            <div className="v-responsive__content">
              <div className="row no-gutters justify-end">
                <div className="col col-12">
                  <div className="mobile-referral-expansion v-item-group theme--light v-expansion-panels v-expansion-panels--accordion v-expansion-panels--flat">
                    <div aria-expanded="false" className="v-expansion-panel">
                      <button
                        type="button"
                        className="v-expansion-panel-header white--text"
                      >
                        <label className="white--text">Referral Program</label>
                        <div className="v-expansion-panel-header__icon">
                          <i
                            aria-hidden="true"
                            className="v-icon notranslate mdi mdi-chevron-down theme--light"
                          />
                        </div>
                      </button>
                      {/**/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mobile-header no-gutters">
            <div className="text-center mobile-header-item col col-6 selected">
              <a
                href="/tier"
                className
                style={{
                  "-webkit-text-decoration": "unset !important",
                  "text-decoration": "unset !important",
                }}
              >
                <span>My Referrals</span>
              </a>
            </div>
            <div className="text-center mobile-header-item col col-6">
              <a
                href="/summary"
                className
                style={{
                  "-webkit-text-decoration": "unset !important",
                  "text-decoration": "unset !important",
                }}
              >
                <span>My Commission</span>
              </a>
            </div>
          </div>
          <div className="v-card__text referralContainer">
            <div className="row hidden-sm-and-down">
              <div className="text-center col col-12">
                <label color="title_color2">
                  Login / register now start earning points
                </label>
              </div>
              <div className="text-center hidden-sm-and-down col col-12">
                <button
                  type="button"
                  className="mr-6 primary-button embedded-login-button pa-2 font-weight-bold yellow--text subtitle-1 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default title_color"
                  style={{ height: "auto" }}
                >
                  <span className="v-btn__content">Login</span>
                </button>
                <button
                  data-v-1dea3caa
                  type="button"
                  className="full-width font-weight-bold pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary subtitle-1 full-width font-weight-bold pa-2 theme-button embedded-register-button"
                >
                  <span className="v-btn__content">Register Now</span>
                </button>
              </div>
              <div className="text-center hidden-md-and-up col col-12">
                <button
                  type="button"
                  className="mr-1 primary-button embedded-mobile-login-button font-weight-bold yellow--text v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default title_color"
                >
                  <span className="v-btn__content">Login</span>
                </button>
                <button
                  data-v-1dea3caa
                  type="button"
                  className="full-width font-weight-bold pa-2 v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default buttonPrimary theme-button embedded-mobile-register-button"
                >
                  <span className="v-btn__content">Register Now</span>
                </button>
              </div>
            </div>
            <div className="mobile-refLayout-before-login-card hidden-md-and-up v-card v-sheet theme--light">
              <div className="row no-gutters">
                <div className="mobile-beforeLogin-text col col-12">
                  Login / register now start earning points
                </div>
                <div className="col col-12">
                  <div
                    className="row"
                    style={{
                      "-webkit-flex-direction": "column",
                      "-ms-flex-direction": "column",
                      "flex-direction": "column",
                      gap: "1rem",
                    }}
                  >
                    <div className="mx-auto inpage-before-login-first text-center beforeLoginBtn col col-7">
                      <b>Sign Up</b>
                    </div>
                    <div className="mx-auto  inpage-navigator-before-login-second text-center beforeLoginBtn col col-7">
                      <b>Login</b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ReferWeb;
